var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('span',{staticClass:"icon"},[(/^https*:\/\//.test(_vm.icon))?_c('img',{staticClass:"icon-img",attrs:{"src":_vm.icon}}):_c('a-icon',{attrs:{"type":_vm.icon}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }